import React, { useState } from "react";
import { Grid, Box, Typography, Button } from "@mui/material";
import "./index.css";
import { Specimen } from "../../../../types";
import { useNavigate } from "react-router";
import { ROUTES } from "../../../../config/routes";

interface Props {
  specimen: Specimen;
  selectedSpecimen: Specimen | null;
  handleSpecimenClick: (specimen: Specimen) => void;
}

const ImageCard: React.FC<Props> = ({
  specimen,
  selectedSpecimen,
  handleSpecimenClick,
}) => {
  const [isHover, setIsHover] = useState<boolean>(false);
  const navigate = useNavigate();

  return (
    <Grid key={specimen.id} data-item-id={specimen.id}>
      <Box
        onClick={(e: React.MouseEvent) => {
          handleSpecimenClick(specimen);
          setIsHover(true);
          e.preventDefault();
          e.stopPropagation();
        }}
        onMouseEnter={() => {
          if (specimen.id === selectedSpecimen?.id) {
            setIsHover(true);
          }
        }}
        onMouseLeave={() => {
          if (specimen.id === selectedSpecimen?.id) {
            setIsHover(false);
          }
        }}
        className="single-image-container"
      >
        {isHover && (
          <div
            className="blurred-background"
            onClick={(e: React.MouseEvent) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <Button
              variant="text"
              className="btn-view-specimen"
              onClick={() => {
                navigate(ROUTES.SPECIMEN);
              }}
            >
              View Specimen
            </Button>
          </div>
        )}
        <div key={specimen.id} className="specimen-card">
          <img
            src={specimen.img}
            alt={specimen.id}
            width={250}
            style={{
              border:
                specimen.id === selectedSpecimen?.id
                  ? "4px #428BCA solid"
                  : "4px #ffffff solid",
            }}
          />
          <Typography sx={{ pl: "4px" }}>
            {specimen?.displayName || specimen.id}
          </Typography>
        </div>
      </Box>
    </Grid>
  );
};

export default ImageCard;
